import { moveDecision } from '@vms/vmspro3-core/dist/actions/decision'
import { Modal, message } from 'antd'
import { useCallback, useState } from 'react'
import { useAppDispatch } from '../../../redux'
import { DecisionFolderTreeSelect } from '../../common/DecisionFolderTreeSelect'

interface MoveDecisionModalProps {
  decisionId: string
  decisionName: string
  srcFolderId: string
  hideModal: VoidFunction
}

export function MoveDecisionModal(props: MoveDecisionModalProps) {
  const { decisionId, decisionName, srcFolderId, hideModal } = props

  const [folderId, setFolderId] = useState(srcFolderId)

  const dispatch = useAppDispatch()

  const onOk = useCallback(() => {
    if (folderId === srcFolderId) {
      message.error('Please select a different folder than the current one.')
      return
    }

    const action = moveDecision(decisionId, folderId)
    dispatch(action)
    hideModal()
    message.info('Moving decision...this may take a few seconds to complete.')
  }, [decisionId, dispatch, folderId, hideModal, srcFolderId])

  return (
    <Modal open onOk={onOk} onCancel={hideModal} title={`Move "${decisionName}"`}>
      <p>Select the folder where you want to move this decision:</p>
      <div style={{ marginTop: '12px' }}>
        <label>
          Target folder:
          <DecisionFolderTreeSelect initialExpandedFolderId={srcFolderId} onSelect={setFolderId} />
        </label>
      </div>
    </Modal>
  )
}
